import { _js } from '@ifixit/utils/localize';
import { FaIcon } from '@ifixit/ui/components/icon';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext, useEditorSelector } from '../../editor_context';

export const RedoButton = () => {
   const { editor } = useEditorContext();
   const state = useEditorSelector(editor => ({
      isDisabled: !editor.can().redo(),
   }));

   if (!state) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().redo().run()}
         isDisabled={state.isDisabled}
         icon={<FaIcon name="arrow-rotate-right" />}
         title={_js('Redo')}
         shortcut={'y'}
      ></TiptapButton>
   );
};
